/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.product_sections
 */
function productSectionDirective() {
    return {
        restrict: 'E',
        scope: {
            name: '@',
            params: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: productSectionController,
        template: require('./productSectionView.html')
    };
}

productSectionController.$inject = [
    'UtilService',
];
function productSectionController (
    UtilService,
) {
    
    this.$onInit = function () {

        let vm = this;
        populateParams();

        const defaultProductSections = {
            section_1: [
                'product_details'
            ],
            section_2: [
                'energy_score',
                'eco_view',
                'energy_cost_savings'
            ],
            section_3: [
                'product_certifications'
            ],
            section_4: [
                'price_chart',
                'price_ranking',
                'online_offers'
            ],
            section_5: [
                'store_locator'
            ],
            section_6: [
                'product_reviews'
            ]
        };

        renderSection();

        function populateParams() {
            if (!vm.params) {
                return;
            }
            vm.product = vm.params.product;
            vm.productEfficiency = vm.params.product_efficiency;
            vm.productImageSizes = vm.params.product_image_sizes;
            vm.productController = vm.params.product_controller;
        }

        function renderSection() {
            let productSectionsSetting = null;
            if (UtilService.isMobile()) {
                productSectionsSetting = UtilService.getSiteSetting('product_sections_mobile', defaultProductSections);
            } else {
                productSectionsSetting = UtilService.getSiteSetting('product_sections_desktop', defaultProductSections);
            }

            if (productSectionsSetting.hasOwnProperty(vm.name)) {
                vm.subSections = productSectionsSetting[vm.name];
            }
        }
    };

}

module.exports = productSectionDirective;
